import axios from 'axios';
import API_ROUTES from '../../routes/ApiRoutes.js';

// Obtener el registro por id
export const getInstructionalLevelById = async (id) => {
    const { data } = await axios.get(`${API_ROUTES.INSTRUCTIONAL_LEVELS}/${id}`);
    return data;
};

// procedimiento actualizar
export const updateInstructionalLevel = async (id, payload) => {
    const { data } = await axios.put(`${API_ROUTES.INSTRUCTIONAL_LEVELS}/${id}`, payload);
    return data;
};